<template>
  <div class="gzdPage">
    <!-- 搜索界面 -->
    <form action="/" class="search" id="searchHeight">
      <van-search
        v-model="searchKeyword"
        placeholder="请输入姓名"
        show-action
        @input="onSearch"
        @cancel="onCancel"
      />
    </form>
    <div class="myZrq clear">
      <van-icon name="location-o" class="gree" />
      <span class="curZrq">当前: {{ currentZrq }}</span>
      <span class="fr textMain" v-if="myZrqList[1]" @click="getZrqList">
        <em>点击切换</em> ></span
      >
    </div>
    <div class="loading" v-if="loading">
      <van-loading size="24px" color="#0094ff" vertical>加载中...</van-loading>
    </div>
    <div class="selectMain" v-else>
      <van-checkbox-group v-model="result" class="roleMain">
        <van-collapse v-model="activeNames" @change="collapseChange" ref="collapse" accordion>
          <van-collapse-item
            v-for="(item, parentIndex) in zqOrgList"
            :key="parentIndex"
            :title="item.areaName"
            :name="item.regionCode"
            class="greeOne"
          >
            <div v-if="item.userList">
              <van-cell
                v-for="(userItem, index) in item.userList"
                clickable
                :key="userItem.uid"
                :title="`${userItem.position + '-' + userItem.realName}`"
                @click="toggle(parentIndex, index, userItem)"
              >
                <van-checkbox
                  :name="`${userItem.position + '-' + userItem.realName}`"
                  :ref="'checkboxes' + userItem.uid"
                  slot="right-icon"
                />
              </van-cell>
            </div>
            <p v-if="!item.isFinished " style="text-align:center;padding-top:15px;">加载中...</p>
            <p v-if="item.isFinished && item.userList.length==0" style="text-align:center;padding-top:15px;">无数据</p>
          </van-collapse-item>
        </van-collapse>
      </van-checkbox-group>
      <div class="nonePage" v-if="!zqOrgList[0]">
        <img :src="nonePng" alt />
        <p>暂无数据</p>
      </div>
    </div>
    <van-popup v-model="zrqListType" round position="bottom">
      <van-picker
        show-toolbar
        value-key="gridName"
        :columns="myZrqList"
        @cancel="zrqListType = false"
        @confirm="onSaveZrqType"
      />
    </van-popup>
    <div class="btnBox clearfix" v-if="this.clientType == 'IOS'">
      <a href="javascript:void(0);" class="closeText" @click="closeText"
        >取消</a
      >
      <a href="javascript:void(0);" class="addText" @click="addText">保存</a>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import nonePng from "@/assets/none.png";
import newApi from "lodash";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { mapState } from "vuex";
import {jsonFormat} from "@/utils/common"
export default {
  name: "selectStaff",
  data() {
    return {
      nonePng: nonePng, //默认图片
      searchKeyword: "", //搜索值
      activeNames: '',
      selectItem: "",
      currentZrq: "", //用户当前责任区
      myZrqList: [], //当前责任区的列表
      zrqListType: false, //弹框
      zqOrgList: [], //政区列表
      Show: false,
      applists: [],
      roleList: [], //角色列表
      result: [], //选择的角色列表
      roledata: [], //选中的角色列表
      cloneRoledata: [],
      roleId: "", //保存的的角色Id
      queryCriteria: "", //搜索关键字
      changeRightType: "",
      changeLeftType: "",
      clientType: "",
      loading: true,
      collapseIndex:-1,
      searchTime:null,
    };
  },
  props: {
    selecLeftType: { String },
    selecRightType: { String },
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(() => {
      this.selectPage();
    });
  },
  methods: {
     onSearch() {
      let _this=this;
			if(this.searchTime){
				clearTimeout(_this.searchTime)
			}
      if(!this.activeNames){
          this.activeNames=this.zqOrgList[0].regionCode;
          this.collapseIndex=0;
        }
        let obj=this.zqOrgList[this.collapseIndex]
        obj.isFinished=false;
        obj.userList=[];
			_this.searchTime=setTimeout(async()=>{
        let list=await this.sendUserList(obj)
        obj.isFinished=true;
        obj.userList=list;
        this.$set(this.zqOrgList,this.collapseIndex,obj)
			},500)
    },
    onCancel() {
      console.log("取消");
      this.onSearch()
    },
    selectPage() {
      if (this.userinfo) {
        this.getOrgMsg();
      } else {
        this.selectPage();
      }
    },
     collapseChange(str){
      if(str){
        this.getUserList(str)
      }
    },
    async getUserList(str){
      let index=this.zqOrgList.findIndex(item=>item.regionCode==str)
      let obj=this.zqOrgList[index]
      this.collapseIndex=index;
      if(!obj.userList){
        let list=await this.sendUserList(obj)
        console.log(this.zqOrgList,'listlistlistlist')
        obj.userList=list;
        obj.isFinished=true;
        this.$set(this.zqOrgList,index,obj)
      }
    },
    getRegionAndGridTree(data){
      var _this = this;
      _this.$api.worker
        .getRegionAndGridTree({
          areaType: data.areaType, //责任区的类型：zq-政区 zrq-责任区
          objid: data.objid, //资源ID
          zqCode: data.zqCode ? data.zqCode : "", //政区编码
          gridLevel: data.gridLevel, //级别
        })
        
        .then((res) => {
          if (res.code == "1" && res.data) {
            _this.zqOrgList = jsonFormat(res.data).reverse();
            console.log( _this.zqOrgList,' _this.zqOrgList')
            _this.getUserList(_this.zqOrgList[0].regionCode)
            _this.activeNames=_this.zqOrgList[0].regionCode;
            _this.collapseIndex=0;
            _this.loading = false;
          } else {
            _this.loading = false;
          }
        });
    },
    async sendUserList(data){
      let _this = this;
      let list = await new Promise((resolve) => {
        _this.$api.worker
        .sendUserList({
          type: data.type, //责任区的类型：zq-政区 zrq-责任区
          objid: data.objid, //资源ID
          regionCode: data.regionCode ? data.regionCode : "", //政区编码
          pageNum:1,
          pageSize:9999,
          realName: _this.searchKeyword,
          uid:_this.userinfo.uid
        }).then((res) => {
          if (res.code == "1" && res.data) {
            resolve(
              res.data.list
            );
          } else {

          }
        });
      });
      return list;
    },
    getOrgMsg() {
      let _this = this;
      _this.$api.worker.indexMyGridSelect(_this.userinfo.uid).then((res) => {
        if (res.code == "1") {
          _this.myZrqList = res.data;
          _this.currentZrq = _this.myZrqList[0].gridName;
          // _this.getGridTreeData(_this.myZrqList[0]);
          _this.getRegionAndGridTree(_this.myZrqList[0])
          this.selectItem = _this.myZrqList[0];
        }
      });
    },
    getZrqList() {
      this.zrqListType = true;
    },
    onSaveZrqType(data) {
      this.loading = true;
      this.zrqListType = false;
      this.currentZrq = data.gridName;
      this.selectItem = data;
      // this.getGridTreeData(data);
      this.getRegionAndGridTree(data);
      // this.$refs.collapse.toggleAll(false);
      this.activeNames='';
    },
    //获取该责任区政区及责任区人员列表
    getGridTreeData(data) {
      var _this = this;
      _this.$api.worker
        .sendAllUserList({
          type: data.areaType, //责任区的类型：zq-政区 zrq-责任区
          objid: data.objid, //资源ID
          regionCode: data.zqCode ? data.zqCode : "", //政区编码
          regionLevel: data.gridLevel, //级别
          selectRange: "2",
          userName: _this.searchKeyword,
          showGrid: true,
        })
        
        .then((res) => {
          if (res.code == "1" && res.data) {
            _this.zqOrgList = res.data;
            _this.loading = false;
          } else {
            _this.loading = false;
          }
        });
    },

    //人员列表添加s
    toggle(parentIndex, index, item) {
      //这里的typeIndex是第几个列表
      this.$refs[`checkboxes${item.uid}`][0].toggle();
      this.roledata.push(item);
      this.unique(this.roledata);
    },
    unique(dataArray) {
      //数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) => item1.uid === item2.uid && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });
      _this.roledata = _this.roledata.filter(function () {
        return true;
      });
      console.log(_this.roledata, "_this.roledata ");
    },
    addText() {
      let _this = this;
      let setData = {};
      let arr = [];
      let arr1 = [];
      let sessionArr = JSON.stringify(newApi.cloneDeep(_this.roledata));
      sessionStorage.clear();
      console.log("sessionArr====" + sessionArr);

      sessionStorage.setItem("sessionarr", sessionArr);
      _this.roledata.forEach((item) => {
        arr1.push(item.uid);
        arr.push(item.realName);
      });

      setData.count = arr.join("，");
      setData.ids = arr1;
      if (this.clientType == "android") {
        if (this.changeRightType == "确定") {
          this.$emit("getRoleData", setData);
          this.changeRightType = "";
        }
      } else {
        this.$emit("getRoleData", setData);
      }
    },
    closeText() {
      let _this = this;
      let setData = {};
      let NewArr = [];
      let countArr = [];
      let sessionArr = JSON.parse(sessionStorage.getItem("sessionarr")) || [];
      if (sessionArr != []) {
        for (let i = 0; i < sessionArr.length; i++) {
          NewArr.push(
            sessionArr[i].orgIdName +
              "-" +
              sessionArr[i].position +
              "-" +
              sessionArr[i].realName
          );
          countArr.push(sessionArr[i].realName);
        }
        _this.result = NewArr;
      } else {
        _this.result = [];
      }

      setData.count = countArr.join("，");
      if (this.clientType == "android") {
        if (this.changeLeftType == "取消") {
          this.$emit("getRoleData", setData);
          this.changeLeftType = "";
        }
      } else {
        this.$emit("getRoleData", setData);
      }
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    selecLeftType: function (newValue) {
      this.changeLeftType = String(newValue);
      this.closeText();
    },
    selecRightType: function (newValue) {
      this.changeRightType = String(newValue);
      this.addText();
    },
  },
};
</script>
<style lang="less" >
.gzdPage {
  width: 100%;
  height: 100%;
  background-color: #f7f8fa;
  padding-bottom: 45px;
  overflow-y: auto;
  position: relative;
  .loading {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
  }
  .myZrq {
    padding: 0 16px;
    height: 40px;
    background-color: #fff;
    margin-top: 8px;
    font-size: 16px;
    color: #666;
    line-height: 40px;
    .gree {
      font-size: 20px;
      color: #36c376;
    }
    .curZrq {
      display: inline-block;
      padding-left: 15px;
    }
    .textMain {
      color: #999;
      em {
        font-weight: 400;
        color: #36c376;
        font-size: 14px;
      }
    }
  }

  .nonePage {
    width: 120px;
    height: 150px;
    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -75px;

    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
  .greeOne .van-cell.van-collapse-item__title {
    background-color: rgba(54, 195, 118, 1);
    color: #fff;
    .van-icon {
      color: #fff;
    }
  }
  .greeTwo {
    background: rgb(54, 195, 118);
    color: #fff;
    opacity: 0.8;
  }
  .greeThree {
    background: rgb(54, 195, 118);
    color: #fff;
    opacity: 0.6;
  }
  .greeFour {
    background: rgb(54, 195, 118);
    color: #fff;
    opacity: 0.4;
  }
  .greeFive {
    background: rgb(54, 195, 118);
    color: #fff;
    opacity: 0.2;
  }
  .noneText {
    width: 100%;
    line-height: 45px;
    text-align: center;
    color: #333;
    font-size: 15px;
    border-bottom: 1px solid rgba(153, 153, 153, 0.2);
  }
  .btnBox {
    width: 100%;
    height: 45px;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    border-top: 1px solid #f3f3f3;
    a {
      display: inline-block;
      width: 50%;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      box-sizing: border-box;
      text-align: center;
    }
    a.closeText {
      border-right: 1px solid #f6f6f6;
      color: #666;
    }
    a.addText {
      color: #36c376;
    }
  }
}
</style>